/* Experiments core, deferred half (docs/experiments-framework-ticket.md).
   ab-assign (inline, head) has already assigned arms. This file:
   1. pushes one ab_exposure per key per page to dataLayer;
   2. stamps every stamped assignment on the cart as _ab_<key> — verified, not
      fire-and-forget: on a first visit there is no cart yet, so this write and
      another attribute writer each create a cart and the last cookie wins (the
      9/3 Intelligems race). Write after a delay, re-read cart.js, compare EVERY
      key, retry with backoff, and re-verify after cart mutations. */
(function () {
  var AB = window.wooj && window.wooj.ab;
  if (!AB) return;
  var want = AB.all();
  var keys = Object.keys(want);
  keys.forEach(function (k) {
    if (window.dataLayer) window.dataLayer.push({ event: 'ab_exposure', key: k, arm: want[k] });
  });
  if (!keys.length) return;

  var attempts = 0, timer = null;
  function stamp(delayMs) {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var a = (cart && cart.attributes) || {};
        var missing = keys.filter(function (k) { return a['_ab_' + k] !== want[k]; });
        if (!missing.length || attempts >= 5) return;
        attempts++;
        var body = { attributes: {} };
        keys.forEach(function (k) { body.attributes['_ab_' + k] = want[k]; });
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function () { stamp(2500 * attempts); }); // verify on the next pass; 2.5s, 5s, 7.5s ...
      }).catch(function () { if (attempts < 5) { attempts++; stamp(2500 * attempts); } }); // 4xx / challenge: same backoff
    }, delayMs || 0);
  }
  function start() {
    stamp(1500); // let the other first-load writers create the cart first
    ['cart:add', 'cart:open', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { attempts = 0; stamp(1200); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
